import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BannerCard } from './BannerCard';
import { BannerDto } from '@/services/banner.service';
import './BannerCarousel.css';

interface BannerCarouselProps {
  banners: BannerDto[];
}

const variants = {
  enter: (dir: number) => ({ x: dir > 0 ? '100%' : '-100%', opacity: 0 }),
  center: { x: 0, opacity: 1 },
  exit: (dir: number) => ({ x: dir > 0 ? '-100%' : '100%', opacity: 0 }),
};

export const BannerCarousel: React.FC<BannerCarouselProps> = ({ banners }) => {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);

  if (banners.length === 0) return null;

  const paginate = (newDir: number) => {
    setDirection(newDir);
    setCurrent((prev) => (prev + newDir + banners.length) % banners.length);
  };

  return (
    <div className="banner-carousel">
      <div className="banner-carousel-track">
        <AnimatePresence initial={false} custom={direction}>
          <motion.div
            key={current}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.35, ease: 'easeInOut' }}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={0.2}
            dragDirectionLock={true}
            onDragEnd={(_e, { offset }) => {
              if (offset.x < -60) paginate(1);
              else if (offset.x > 60) paginate(-1);
            }}
            className="banner-carousel-slide"
          >
            <BannerCard banner={banners[current]} />
          </motion.div>
        </AnimatePresence>
      </div>
      {banners.length > 1 && (
        <div className="banner-carousel-dots">
          {banners.map((_, i) => (
            <button
              key={i}
              className={`banner-dot${i === current ? ' active' : ''}`}
              onClick={() => {
                setDirection(i > current ? 1 : -1);
                setCurrent(i);
              }}
              aria-label={`Go to banner ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
